import { render, staticRenderFns } from "./ztAlert.vue?vue&type=template&id=19f0ba6a&scoped=true"
import script from "./ztAlert.vue?vue&type=script&lang=js"
export * from "./ztAlert.vue?vue&type=script&lang=js"
import style0 from "../../../../../src/styles/components/ztAlert.css?vue&type=style&index=0&id=19f0ba6a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f0ba6a",
  null
  
)

export default component.exports